/**
 * Stable CSS class names for E2E — pages/SiteManagement/GlobalDataTokenManagement.
 * Containers use `global-data-token__<element>`; inputs and user-interactable
 * controls use `global-data-token-input--<name>`.
 */
export const GDT = {
    page: 'global-data-token-page',
    root: 'global-data-token',

    /* --- Header -------------------------------------------------------- */
    breadcrumb: 'global-data-token__breadcrumb',

    /* --- Drawer (add / update) ---------------------------------------- */
    drawer: 'global-data-token__drawer',
    drawerCard: 'global-data-token__drawer-card',
    drawerCardContent: 'global-data-token__drawer-card-content',
    drawerInner: 'global-data-token__drawer-inner',
    drawerHeaderRow: 'global-data-token__drawer-header-row',
    drawerTitleBox: 'global-data-token__drawer-title-box',
    drawerTitle: 'global-data-token__drawer-title',
    drawerCloseBox: 'global-data-token__drawer-close-box',
    btnDrawerClose: 'global-data-token-input--button-drawer-close',
    drawerFieldRow: 'global-data-token__drawer-field-row',
    drawerFieldToken: 'global-data-token__drawer-field-token',
    inputDrawerToken: 'global-data-token-input--drawer-token',
    drawerActions: 'global-data-token__drawer-actions',
    btnDrawerSave: 'global-data-token-input--button-drawer-save',

    /* --- Toolbar ------------------------------------------------------- */
    toolbar: 'global-data-token__toolbar',
    btnAddToken: 'global-data-token-input--button-add-token',

    /* --- Grid wrapper -------------------------------------------------- */
    gridBox: 'global-data-token__grid-box',
    grid: 'global-data-token__grid',

    /* --- Grid cells ---------------------------------------------------- */
    cellTokenName: 'global-data-token__cell-token-name',
    cellTokenKey: 'global-data-token__cell-token-key',
    cellTokenKeyText: 'global-data-token__cell-token-key-text',
    cellCreatedBy: 'global-data-token__cell-created-by',
    cellActions: 'global-data-token__cell-actions',
    btnRowMenu: 'global-data-token-input--button-row-menu',
    rowMenu: 'global-data-token__row-menu',
    rowMenuItem: 'global-data-token__row-menu-item',
    rowMenuItemRefresh: 'global-data-token__row-menu-item--refresh',
    rowMenuItemDelete: 'global-data-token__row-menu-item--delete',
    rowMenuItemText: 'global-data-token__row-menu-item-text',
} as const;

export const gdtCls = (...parts: Array<string | undefined | false>) => parts.filter(Boolean).join(' ');
